
import Vue from "vue";
import fieldEntryMixin from "@/components/mixins/fieldEntryMixin.vue";
import AppPropsMixin from "@/components/mixins/AppPropsMixin.vue";
import store from "../store";
import { mapGetters } from "vuex";
import { IInvoicePayment } from "../types";

export default Vue.extend({
  name: "invoice-review",
  mixins: [fieldEntryMixin, AppPropsMixin],
  computed: {
    invoicePayment(): IInvoicePayment {
      //@ts-ignore
      return store.getters.invoiceModule.getInvoicePayment;
    },
    amountPaying(): string {
      //@ts-ignore
      return this.formatPrice(
        //@ts-ignore
        store.getters.invoiceModule.getInvoicePayment.amountPaying
      );
    },
    amountDue(): string {
      //@ts-ignore
      return this.formatPrice(
        //@ts-ignore
        store.getters.invoiceModule.getInvoicePayment.amountDue
      );
    },
    amountDueAndPayingMatch(): boolean {
      return this.amountDue === this.amountPaying;
    }
  }
});
